<template>
  <div class="content">
    <div v-if="type==1">
      <div class="page" v-show="index==0">
        <div class="title">员工信息登记</div>
          <van-form :show-error-message="false" :scroll-to-error="true" @submit="onSubmit">
            <div class="tit">*请选择入职门店</div>
            <van-cell-group inset>
              <van-field
                v-model="shopName"
                is-link
                readonly
                name="picker"
                placeholder="点击选择门店"
                @click="showPicker = false"/>
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
          </van-cell-group>
          <div class="tit">请输入手机号</div>
          <van-field v-model="mobile" name="mobile" placeholder="请输入手机号" :rules="telRules2"/>
          <div style="margin: 0.6rem 0;">
            <van-button round block type="primary" native-type="submit" :loading="loading">
              开始填写
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==1">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit">
          <div class="tmt">基本信息</div>
          <div class="txt"><i>*</i>1.姓名</div>
          <van-field v-model="guide.guideName" name="guideName" placeholder="请输入姓名" :readonly="guide.documentStatus && guide.documentStatus==2" :rules="[{ required: true, message: '请输入姓名' }]"/>
          <div class="txt"><i>*</i>2.身份证类型</div>
          <van-field name="certificate" class="noborder">
            <template #input>
              <van-radio-group v-model="certificate.guideIdType" :disabled="guide.documentStatus && guide.documentStatus==2">
                  <van-radio name="1">身份证</van-radio>
                  <van-radio name="2">护照</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="txt"><i>*</i>3.{{Number(certificate.guideIdType)==1?'身份证号':'护照号'}}</div>
          <van-field v-if="Number(certificate.guideIdType)==1" v-model="guide.guideIdCard" @input="getidcard" name="guideIdCard" placeholder="请输入身份证号" :rules="telRules3" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <van-field v-if="Number(certificate.guideIdType)==2" v-model="certificate.guidePassportNo" name="guidePassportNo" placeholder="请输入护照号" :rules="[{ required: true, message: '请输入护照号' }]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt" v-if="Number(certificate.guideIdType)==2"><i>*</i>护照签发日期</div>
          <van-field v-if="Number(certificate.guideIdType)==2" readonly clickable name="guidePassportStartTime" :value="certificate.guidePassportStartTime" placeholder="请选择护照签发日期" :rules="[{ required: true, message: '请选择护照签发日期' }]" @click="getshowPicker47"  />
              <van-popup v-model="showPicker47" position="bottom">
              <van-datetime-picker
                  v-model="currentDate47"
                  type="date"
                  :min-date="minDate"
                  :max-date="maxDate1"
                  @confirm="onConfirmtwo47"
                  @cancel="showPicker47 = false"/>
              </van-popup>
          <div class="txt" v-if="Number(certificate.guideIdType)==2"><i>*</i>护照有效期至</div>
          <van-field v-if="Number(certificate.guideIdType)==2" readonly clickable name="guidePassportEndTime" :value="certificate.guidePassportEndTime" placeholder="请选择护照有效期至" :rules="[{ required: true, message: '请选择护照有效期至' }]" @click="getshowPicker48" />
              <van-popup v-model="showPicker48" position="bottom">
              <van-datetime-picker
                  v-model="currentDate48"
                  type="date"
                  :min-date="minDate"
                  :max-date="maxDate1"
                  @confirm="onConfirmtwo48"
                  @cancel="showPicker48 = false"/>
              </van-popup>
          <div class="txt"><i>*</i>4.性别</div>
          <van-field name="uploader" class="noborder">
            <template #input>
              <van-radio-group v-model="guide.guideSex" :disabled="guide.documentStatus && guide.documentStatus==2">
                  <van-radio name="1">男</van-radio>
                  <van-radio name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="txt"><i>*</i>5.民族</div>
          <van-field v-model="guide.guideNation" name="guideNation" placeholder="请输入民族" :rules="[{ required: true, message: '请输入民族' }]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt"><i>*</i>6.生日</div>
          <van-field readonly clickable name="date" :value="guide.guideBirthday" placeholder="请选择生日" :rules="[{ required: true, message: '请选择生日' }]"
              @click="getshowPicker" />
              <van-popup v-model="showPicker1" position="bottom">
              <van-datetime-picker
                  v-model="currentDate"
                  type="date"
                  :min-date="minDate"
                  :max-date="maxDate"
                  @confirm="onConfirmtwo"
                  @cancel="showPicker1 = false"/>
              </van-popup>
          <div class="txt"><i>*</i>7.身高(cm)</div>
          <van-field v-model="guide.height" type="digit" placeholder="请输入身高" :rules="[{ required: true, message: '请输入身高' }]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <!-- <van-cell-group inset>
              <van-field
                v-model="guide.height"
                is-link
                readonly
                name="picker"
                placeholder="点击选择身高"
                :rules="[{ required: true, message: '请选择身高' }]"
                @click="showPicker3 = guide.documentStatus==2?false:true"/>
              <van-popup v-model="showPicker3" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="heightList"
                  @confirm="onConfirm3"
                  @cancel="showPicker3 = false"
                />
              </van-popup>
          </van-cell-group> -->
          <div class="txt"><i>*</i>8.手机号</div>
          <van-field v-model="guide.guideMobile" name="guideMobile" placeholder="请输入手机号" :rules="telRules2" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt"><i>*</i>9.学历</div>
          <van-cell-group inset>
              <van-field
                v-model="guide.educationCodeName"
                is-link
                readonly
                name="picker"
                placeholder="点击选择学历"
                :rules="[{ required: true, message: '请选择学历' }]"
                @click="showPicker2 = true"/>
              <van-popup v-model="showPicker2" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="columns2"
                  @confirm="onConfirm2"
                  @cancel="showPicker2 = false"
                />
              </van-popup>
          </van-cell-group>
          <div class="txt"><i>*</i>10.籍贯</div>
          <van-field v-model="guide.guideNativePlace" name="guideNativePlace" placeholder="请输入籍贯" :rules="[{ required: true, message: '请输入籍贯' }]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt" v-if="Number(certificate.guideIdType)==1"><i>*</i>11.身份证地址</div>
          <van-field v-if="Number(certificate.guideIdType)==1" v-model="guide.guideHomeAddr" name="guideHomeAddr" placeholder="请输入身份证地址" :rules="[{ required: true, message: '请输入身份证地址'}]" @input="getaddre" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt"><i>*</i>{{Number(certificate.guideIdType)==1?'12':'11'}}.现住址</div>
          <van-field v-model="guide.guideCurrentAddr" name="guideCurrentAddr" placeholder="请输入现住址" :rules="[{ required: true, message: '请输入现住址'}]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt">{{Number(certificate.guideIdType)==1?'13':'12'}}.邮箱</div>
          <van-field v-model="guide.guideEmail" placeholder="请输入邮箱" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="txt"><i>*</i>{{Number(certificate.guideIdType)==1?'14':'13'}}.上传一寸证件照</div>
          <van-field name="idPhotoImg" class="noborder" :rules="[{ required: picture.idPhotoImg==''?true:false, message: '请上传证件照上传' }]">
            <template #input>
              <van-uploader v-if="picture.idPhotoImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 10)" multiple :max-count="1" show-upload upload-text="证件照" :readonly="guide.documentStatus && guide.documentStatus==2">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.idPhotoImg)" :src="picture.idPhotoImg"/>
                <i @click="delimg(10)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div style="margin: 0.6rem 0;">
            <van-button round block type="primary" native-type="submit" :loading="loading">
              下一步
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==2">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit2">
          <div class="tmt">就职单位</div>
          <div class="txt"><i>*</i>1.公司名称</div>
          <van-field v-model="company.company" name="companyName" placeholder="请输入公司名称" :rules="[{ required: true, message: '请输入公司名称' }]" :readonly="guide.documentStatus && guide.documentStatus==2">
            <template #button>
              <div class="van-field__left-icon" @click.prevent="getshowsupply()">
                <i class="van-badge__wrapper van-icon van-icon-search"></i>
              </div>
              <!-- <van-button size="small" type="primary" @click.prevent="showsupply=true">筛选</van-button> -->
            </template>
          </van-field>

          <div class="txt"><i>*</i>2.就职品牌</div>
          <van-field v-model="company.brand" name="brandName" placeholder="请输入就职品牌" :rules="[{ required: true, message: '请输入就职品牌' }]" :readonly="guide.documentStatus && guide.documentStatus==2">
            <template #button>
              <div class="van-field__left-icon" @click.prevent="getshowbrand()">
                <i class="van-badge__wrapper van-icon van-icon-search"></i>
              </div>
              <!-- <van-button size="small" type="primary" @click.prevent="showsupply=true">筛选</van-button> -->
            </template>
          </van-field>
          <div class="txt"><i>*</i>3.职位</div>
          <van-field v-model="company.position" name="position" placeholder="请输入职位" :rules="[{ required: true, message: '请输入职位' }]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" native-type="button" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==3">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit3">
          <div v-for="(item,index) in familyList" :key="index">
            <div class="tmt">
              <span>紧急联系人{{index+1}}</span>
              <img v-if="index>0" @click="delfamily(index)" src="@/assets/del.png"/>
            </div>
            <div class="txt"><i>*</i>1.关系</div>
            <van-cell-group inset>
              <van-field
                v-model="item.memberRelation"
                is-link
                readonly
                name="picker"
                placeholder="点击紧急联系人关系"
                :rules="[{ required: true, message: '请填写紧急联系人关系' }]"
                @click="getshowgent(index)"/>
              <van-popup v-model="showgent" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="gentcolumns"
                  @confirm="onConfirmgent"
                  @cancel="showgent = false"
                />
              </van-popup>
          </van-cell-group>
            <!-- <van-field v-model="item.memberRelation" name="memberRelation" placeholder="请填写紧急联系人关系" :readonly="guide.documentStatus==2?true:false" :rules="[{ required: true, message: '请填写紧急联系人关系' }]"/> -->
            <div class="txt"><i>*</i>2.姓名</div>
            <van-field v-model="item.memberName" name="memberName" placeholder="请填写紧急联系人姓名" :rules="[{ required: true, message: '请填写紧急联系人姓名' }]" :readonly="guide.documentStatus && guide.documentStatus==2"/>
            <div class="txt"><i>*</i>3.联系方式</div>
            <van-field v-model="item.memberMobile" name="memberMobile" placeholder="请填写紧急联系方式" :rules="telRules2" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          </div>
          <van-button icon="plus" type="primary" size="small" @click="addfamily()" style="margin-top:15px;" v-if="!guide.documentStatus || guide.documentStatus=='' || guide.documentStatus==1">添加紧急联系人</van-button>
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary"  @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==4">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit4">

          <div v-for="(item,index) in workList" :key="index">
            <div class="tmt">
              <span>工作经历{{index+1}}</span>
              <img @click="delwork(index)" src="@/assets/del.png" v-if="!guide.documentStatus || guide.documentStatus=='' || guide.documentStatus==1"/>
            </div>
            <div class="txt">1.工作单位</div>
            <van-field v-model="item.company" name="company" placeholder="请填写工作单位" :readonly="guide.documentStatus && guide.documentStatus==2"/>
            <div class="txt">2.职务</div>
            <van-field v-model="item.position" name="position" placeholder="请填写职务" :readonly="guide.documentStatus && guide.documentStatus==2"/>
            <div class="txt">3.就职日期</div>
            <van-field readonly clickable name="date" :value="item.entryTime" placeholder="请填写就职日期"
              @click="getshowPicker7" />
              <van-popup v-model="showPicker7" position="bottom">
              <van-datetime-picker
                  v-model="currentDate7"
                  type="date"
                  @confirm="onConfirmtwo7(item)"
                  @cancel="showPicker7 = false"/>
              </van-popup>
            <!-- <van-field v-model="item.entryTime" name="entryTime" placeholder="请填写就职日期" :rules="[{ required: true, message: '请填写就职日期' }]"/> -->
            <div class="txt">4.离职日期</div>
            <van-field readonly clickable name="date" :value="item.resignTime" placeholder="请填写离职日期"
              @click="getshowPicker8" />
              <van-popup v-model="showPicker8" position="bottom">
              <van-datetime-picker
                  v-model="currentDate8"
                  type="date"
                  @confirm="onConfirmtwo8(item)"
                  @cancel="showPicker8 = false"/>
              </van-popup>
            <!-- <van-field v-model="item.resignTime" name="resignTime" placeholder="请填写离职日期" :rules="[{ required: true, message: '请填写离职日期' }]"/> -->
            <div class="txt">5.离职原因</div>
            <van-field v-model="item.resignReason" name="resignReason" placeholder="请填写离职原因" :readonly="guide.documentStatus && guide.documentStatus==2"/>
          </div>
          <van-button icon="plus" type="primary" size="small" @click="addwork()" style="margin-top:15px;" v-if="!guide.documentStatus || guide.documentStatus=='' || guide.documentStatus==1">添加工作经历</van-button>
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==5">
        <div class="title">员工信息登记</div>
        <van-form :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>1.身份证人脸照</div>
          <van-field name="idCardFaceImg" class="noborder zm" placeholder="身份证人脸照" :rules="[{ required: picture.idCardFaceImg==''?true:false, message: '请上传身份证人脸照照片' }]">
            <template #input>
              <van-uploader v-if="picture.idCardFaceImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 0)" multiple :max-count="1" show-upload upload-text="身份证人脸照">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.idCardFaceImg)" :src="picture.idCardFaceImg"/>
                <i @click="delimg(0)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt"><i>*</i>2.身份证国徽照</div>
          <van-field name="idCardEmblemImg" class="noborder fm" :rules="[{ required: picture.idCardEmblemImg==''?true:false, message: '请上传身份证国徽照照片' }]">
            <template #input>
              <van-uploader v-if="picture.idCardEmblemImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 1)"  multiple :max-count="1" show-upload upload-text="身份证国徽照"/>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.idCardEmblemImg)" :src="picture.idCardEmblemImg"/>
                <i @click="delimg(1)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss" :class="age<18?'':'formfoot'">支持上传jpg、jpeg、png格式</div>
        <div v-if="age<18">
          <div class="tmt">附件上传</div>
          <div class="txt"><i>*</i>3.电子合同</div>
          <van-field name="electronicContract" class="noborder notop" placeholder="电子合同" :rules="[{ required: age<18 && guide.electronicContract=='' || guide.electronicContract==null?true:false, message: '请上传电子合同' }]" v-if="!guide.electronicContract || guide.electronicContract=='' || guide.electronicContract==null">
            <template #input>
              <van-uploader class="noheight" v-model="guide.idCardEmblemImg" :max-count="1" accept="image/*,.pdf,.docx"  :before-read="beforeRead1" :disabled="guide.documentStatus && guide.documentStatus==2?true:false"> 
                  <van-button icon="plus" type="primary" size="small">上传文件</van-button>
              </van-uploader>
            </template>
          </van-field>
          <div class="row-between" v-else>
            <div class="name" @click="show=true">电子合同</div>
            <img style="width:0.5rem;height:0.5rem" @click="guide.electronicContract='';" v-if="!guide.documentStatus || guide.documentStatus=='' || guide.documentStatus==1" src="@/assets/del.png"/>
          </div>
          <div class="tipss formfoot">支持上传jpg、jpeg、png、pdf、docx格式</div>
        </div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==6">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false"  @submit="goSubmit6">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>1.健康证{{shopSid==21012?'所属人员姓名':'编号'}}</div>
          <van-field v-model="certificate.healthCartNo" name="healthCartNo" :placeholder="'请填写健康证'+(shopSid==101?'所属人员姓名':'编号')" :rules="[{ required: true, message: '请填写健康证编号' }]"/>
          <div class="txt"><i>*</i>2.健康证有效期</div>
          <van-field v-model="certificate.healthCartEndtime" readonly name="healthCartEndtime" placeholder="请选择健康证结束时间" @click="getshowPicker2" :rules="[{ required: true, message: '请填写健康证结束时间' }]"/>
              <van-popup v-model="showPicker5" position="bottom">
              <van-datetime-picker
                  v-model="currentDate2"
                  type="date"
                  @confirm="onConfirmtwo2"
                  @cancel="showPicker5 = false"/>
              </van-popup>
          <div class="txt"><i>*</i>3.上传健康证附件</div>
          <van-field name="healthCertificateImg" class="noborder" :rules="[{ required: picture.healthCertificateImg==''?true:false, message: '请上传上传健康证附件' }]">
            <template #input>
              <van-uploader v-if="picture.healthCertificateImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 2)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.healthCertificateImg)" :src="picture.healthCertificateImg"/>
                <i @click="delimg(2)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div v-if="shopSid!=21012">
            <div class="txt">4.居住证编码</div>
            <van-field v-model="certificate.residencePermitNo" name="residencePermitNo" placeholder="请填写居住证编码" :readonly="guide.documentStatus && guide.documentStatus==2"/>
            <div class="txt">5.居住证有效期</div>
            <van-field readonly clickable name="kitasEndtime" :value="certificate.kitasEndtime" placeholder="请选择居住证有效期" @click="getshowPicker3"/>
            <van-popup v-model="showPicker6" position="bottom">
            <van-datetime-picker
                v-model="currentDate3"
                type="date"
                @confirm="onConfirmtwo3"
                @cancel="showPicker6 = false"/>
            </van-popup>
          </div>
          
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==7">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">证件信息</div>
          <div class="txt">上传学历证附件</div>
          <van-field name="academicCertificateImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.academicCertificateImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 3)" multiple :max-count="1" show-upload upload-text="上传附件" :readonly="guide.documentStatus && guide.documentStatus==2">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.academicCertificateImg)" :src="picture.academicCertificateImg"/>
                <i @click="delimg(3)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==8">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>上传介绍信附件</div>
          <van-field name="letterImg" class="noborder" :rules="[{ required: picture.letterImg==''?true:false, message: '请上传上传介绍信附件' }]" :readonly="guide.documentStatus && guide.documentStatus==2">
            <template #input>
              <van-uploader v-if="picture.letterImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 4)" multiple :max-count="1" show-upload upload-text="上传附件" :disabled="guide.documentStatus && guide.documentStatus==2">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.letterImg)" :src="picture.letterImg" :readonly="guide.documentStatus && guide.documentStatus==2"/>
                <i @click="delimg(4)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==9">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">其他附件</div>
          <div v-if="shopSid!=21012">
              <div class="txt">居住证</div>
              <van-field name="residencePermitImg" class="noborder">
                <template #input>
                  <van-uploader v-if="picture.residencePermitImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 5)" multiple :max-count="1" show-upload upload-text="上传附件" :readonly="guide.documentStatus && guide.documentStatus==2">
                  </van-uploader>
                  <div class="widbox" v-else>
                    <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.residencePermitImg)" :src="picture.residencePermitImg"/>
                    <i @click="delimg(5)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
                  </div>
                </template>
              </van-field>
              <div class="tipss">支持上传jpg、jpeg、png格式</div>
          </div>
          <!-- <div class="txt"><i>*</i>核酸报告</div>
          <van-field name="nucleicAcidImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.nucleicAcidImg==''" :disabled="guide.documentStatus==2?true:false" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 6)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.nucleicAcidImg)" :src="picture.nucleicAcidImg"/>
                <i @click="delimg(6)" v-if="!guide.documentStatus || guide.documentStatus!=2">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div> -->
          <div class="txt">健康宝个人信息自查</div>
          <van-field name="healthCodeImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.healthCodeImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 7)" multiple :max-count="1" show-upload upload-text="上传附件" :readonly="guide.documentStatus && guide.documentStatus==2">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.healthCodeImg)" :src="picture.healthCodeImg"/>
                <i @click="delimg(7)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt">行程码</div>
          <van-field name="tripCodeImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.tripCodeImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 8)" multiple :max-count="1" show-upload upload-text="上传附件" :readonly="guide.documentStatus && guide.documentStatus==2">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.tripCodeImg)" :src="picture.tripCodeImg"/>
                <i @click="delimg(8)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt">是否接种疫苗</div>
          <van-field name="uploader" class="noborder">
            <template #input>
              <van-radio-group v-model="picture.vaccinesFlag" :disabled="guide.documentStatus && guide.documentStatus==2">
                  <van-radio name="0">未接种</van-radio>
                  <van-radio name="1">已接种</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-show="Number(picture.vaccinesFlag==1)">
            <div class="txt">第一次接种时间</div>
            <van-field readonly clickable name="firstVaccinationTime" :value="picture.firstVaccinationTime" placeholder="请选择第一次接种时间" @click="getshowPicker4"/>
                <van-popup v-model="showPicker44" position="bottom">
                <van-datetime-picker
                    v-model="currentDate44"
                    type="date"
                    @confirm="onConfirmtwo44"
                    @cancel="showPicker44 = false"/>
                </van-popup>
            <div class="txt">第二次接种时间</div>
            <van-field readonly clickable name="secondVaccinationTime" :value="picture.secondVaccinationTime" placeholder="请选择第二次接种时间" @click="getshowPicker5"/>
                <van-popup v-model="showPicker45" position="bottom">
                <van-datetime-picker
                    v-model="currentDate45"
                    type="date"
                    @confirm="onConfirmtwo45"
                    @cancel="showPicker45 = false"/>
                </van-popup>
            <div class="txt">第三次接种时间</div>
            <van-field readonly clickable name="thirdVaccinationTime" :value="picture.thirdVaccinationTime" placeholder="请选择第三次接种时间" @click="getshowPicker6"/>
              <van-popup v-model="showPicker46" position="bottom">
              <van-datetime-picker
                  v-model="currentDate46"
                  type="date"
                  @confirm="onConfirmtwo46"
                  @cancel="showPicker46 = false"/>
              </van-popup>
            <div class="txt">疫苗</div>
            <van-field name="vaccinesImg" class="noborder">
              <template #input>
                <van-uploader v-if="picture.vaccinesImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 9)" multiple :max-count="1" show-upload upload-text="上传附件" :readonly="guide.documentStatus && guide.documentStatus==2">
                </van-uploader>
                <div class="widbox" v-else>
                  <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.vaccinesImg)" :src="picture.vaccinesImg"/>
                  <i @click="delimg(9)" v-if="!guide.documentStatus || guide.documentStatus==1">x</i>
                </div>
              </template>
            </van-field>
            <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          </div>
          <div v-show="Number(picture.vaccinesFlag==0)" class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page promise" v-if="index==10">
        <div @click="getsignshow()" ref="faultTree">
          <div class="protit">承诺书（一）</div>
          <div class="probox">
            <p>{{shopCompany}}∶</p>
            <p class="indent">本人愿意向贵公司提供个人信息记录，并同意贵公司根据供应商之委托，自行选择将该信息提供给任何或全部供应商，以便于协助本人获得充分的就业机会。本人与供应商双向自愿选择，自主确认是否受聘于供应商。若本人未受聘于供应商或与供应商劳动关系终止后，本人愿意继续委托贵公司向其他供应商提供本人个人信息。</p>
            <p class="indent">本人理解贵公司与本人之间不存在劳动或劳务关系；贵公司不因接受本人信息而对本人承担任何提供就有机会的责任。</p>
            <p class="indent">本承诺书自本人签字之日起生效。</p>
            <p class="indent">承诺人（签字）∶</p>
            <p>

                <img v-if="sign1=='' && picture.commitmentOneImg && picture.commitmentOneImg!=''" :src="picture.commitmentSignOneImg"/>
                <img v-if="sign1 && sign1!=''" :src="sign1"/>
            </p>
            <div class="prodate">{{data}}</div>
          </div>
        </div>
        <div class="probox">
          <div class="foot">
            <van-checkbox v-model="checked" shape="square" :disabled="guide.documentStatus && guide.documentStatus==2">本人已阅读协议并签字</van-checkbox>
            <van-button type="primary" block @click.stop="getsubmit()" :loading="loading">下一步</van-button>
          </div>
        </div>
      </div>
      <div class="page promise" v-if="index==11">
        <div @click="getsignshow()" ref="faultTree">
          <div class="protit">承诺书（二）</div>
          <div class="probox">
            <p>{{shopCompany}}∶</p>
            <p class="indent">本人受有意成为在贵公司经营场地（下称“卖场”）内，与贵公司建业联营或其他合作关系的供应商（下称“供应商”）的派遣到卖场作为导购员，为供应商销售产品。</p>
            <p class="indent">本人理解贵公司与本人之间不存在任何劳动或劳务关系，本人将自行要求与供应商依法及时签署劳动合同或劳务合同并办理各项劳动用工手续，已供应商依法建立劳动或劳务关系，并要求供应商就社会保险、工伤赔偿、劳资纠纷等事宜依法承担用人单位的义务与责任。</p>
            <p class="indent">本人同意并认可贵公司为保证卖场的统一管理及销售形象，依据与供应商的联营或其他合作关系，对本人及卖场内其他导购员进行统一管理和考核，包括但不限于办理统一胸口、穿着统一工服、执行统一规章制度、接受入店考核、参加安全培训等。本人认可并愿意遵守贵公司《营业员手册》中规定的各项规章制度，并同意贵公司卖场管理者的依据《营业员手册》中的规定对本人进行考核和进行相应的管理。本人理解并同意，上述统一管理和考核在任何方面不应该被解释为贵公司与本人之间存在劳动或劳务关系，也不应该在任何方面被视为减轻供应商作为用人单位的义务或责任。</p>
            <p class="indent">本人同意并确认：无论本人与供应商之间是否签署劳动或劳务合同、是否存在劳动或劳务关系，本人在任何是偶均不会以任何理由主张与贵公司之间存在劳动或劳务合同，亦不会以任何理由要求贵公司承担用人单位的任何义务或责任。</p>
            <p class="indent">本承诺书自本人签字之日起生效。</p>
            <p class="indent">承诺人（签字）∶</p>
            <p>
                <img v-if="sign2=='' && picture.commitmentTwoImg && picture.commitmentTwoImg!=''" :src="picture.commitmentSignTwoImg"/>
                <img v-if="sign2 && sign2!=''" :src="sign2"/>
                <!-- <img :src="picture.commitmentSignTwoImg"/> -->
            </p>
            <div class="prodate">{{data}}</div>
          </div>
        </div>
        <div class="probox">
          <div class="foot">
            <van-checkbox v-model="checked1" shape="square" :disabled="guide.documentStatus && guide.documentStatus==2">本人已阅读协议并签字</van-checkbox>
            <van-button type="primary" block @click.stop="getsubmit2()" :loading="loading">下一步</van-button>
          </div>
        </div>
      </div>
      <div class="page" v-if="index==12">
        <div class="boximg flexcenter">
          <img src="@/assets/suc.png"/>
          <div class="text" v-if="!guide.documentStatus || guide.documentStatus!=2">
            <div class="btit flexcenter">提交成功</div>
            <p>感谢您的提交，信息将在几日内完成审核，请耐心等待</p>
          </div>
          <div class="text" v-else>
            <div class="btit flexcenter">您已通过审核</div>
          </div>
        </div>
      </div>
      <van-popup v-model="signshow" :style="{ height: '60vh',width:'90%'}">
        <div class="esignTest" style="width:100%;heigth:100%" v-if="signshow">
          <vue-esign ref="esign" :width="800" :height="700"  :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
            <div class="btn">
              <van-button round block type="primary" @click="handleReset">重置</van-button>
              <van-button round block type="primary" @click="handleGenerate">确定</van-button>
          </div>
      </div>
      </van-popup>
      <div v-if="showsupply">
        <van-popup
          v-model="showsupply"
          position="bottom"
          :style="{ height: '60%' }">
          <van-search v-model="supply" @input="set" placeholder="请输入搜索关键词" />
          <van-list finished-text="没有更多了">
            <van-cell v-for="(item,index) in filterList" :key="index" @click="gosupply(index)">
              <div v-html="item.name"></div>
            </van-cell>
          </van-list>
        </van-popup>
      </div>

      <div v-if="showbrand">
        <van-popup
          v-model="showbrand"
          position="bottom"
          :style="{ height: '60%' }">
          <van-search v-model="brand" @input="setbrand" placeholder="请输入搜索关键词" />
          <van-list finished-text="没有更多了">
            <van-cell v-for="(item,index) in brandList1" :key="index" @click="gobrand(index)">
              <div v-html="item.name"></div>
            </van-cell>
          </van-list>
        </van-popup>
      </div>
    </div>
    <div v-if="type==2">
      <div class="page" v-show="index==0">
          <div class="title">员工信息登记</div>
          <van-form :show-error-message="false" :scroll-to-error="true" @submit="onSubmit">
            <div class="tit">请选择入职门店</div>
            <van-cell-group inset>
              <van-field
                v-model="shopName"
                is-link
                readonly
                name="picker"
                placeholder="点击选择门店"
                :rules="[{ required: true, message: '请先选择门店' }]"
                @click="showPicker = true"/>
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  :show-toolbar="true"
                  :columns="shoplist"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
            </van-cell-group>
            <div class="tit">请输入员工手机号</div>
            <van-field v-model="mobile" name="mobile" placeholder="请输入员工手机号" :rules="telRules2"/>
            <div style="margin: 0.6rem 0;">
              <van-button round block type="primary" native-type="submit" :loading="loading">
                下一步
              </van-button>
            </div>
          </van-form>
      </div>
      <div class="page" v-show="index==1">
        <div class="title">员工信息登记</div>
        <van-form :scroll-to-error="true" @submit="goSubmit">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>1.上传一寸证件照</div>
          <van-field name="idPhotoImg" class="noborder" :rules="[{ required: picture.idPhotoImg==''?true:false, message: '请上传证件照上传' }]">
            <template #input>
              <van-uploader v-if="picture.idPhotoImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 10)" multiple :max-count="1" show-upload upload-text="证件照">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.idPhotoImg)" :src="picture.idPhotoImg"/>
                <i @click="delimg(10)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div style="margin: 0.6rem 0;">
            <van-button round block type="primary" native-type="submit" :loading="loading">
              下一步
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==2">
        <div class="title">员工信息登记</div>
        <van-form :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>1.身份证人脸照</div>
          <van-field name="idCardFaceImg" class="noborder zm" :rules="[{ required: picture.idCardFaceImg==''?true:false, message: '请上传身份证人脸照照片' }]">
            <template #input>
              <van-uploader v-if="picture.idCardFaceImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 0)" multiple :max-count="1" show-upload upload-text="身份证正面">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.idCardFaceImg)" :src="picture.idCardFaceImg"/>
                <i @click="delimg(0)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt"><i>*</i>2.身份证国徽照</div>
          <van-field name="idCardEmblemImg" class="noborder fm" :rules="[{ required: picture.idCardEmblemImg==''?true:false, message: '请上传身份证国徽照照片' }]">
            <template #input>
              <van-uploader v-if="picture.idCardEmblemImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 1)"  multiple :max-count="1" show-upload  upload-text="身份证反面"/>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.idCardEmblemImg)" :src="picture.idCardEmblemImg"/>
                <i @click="delimg(1)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==3">
        <div class="title">员工信息登记</div>
        <van-form :scroll-to-error="true" @submit="goSubmit6">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>1.上传健康证附件</div>
          <van-field name="healthCertificateImg" class="noborder" :rules="[{ required: picture.healthCertificateImg==''?true:false, message: '请上传健康证附件' }]">
            <template #input>
              <van-uploader v-if="picture.healthCertificateImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 2)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.healthCertificateImg)" :src="picture.healthCertificateImg"/>
                <i @click="delimg(2)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="formfoot"></div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==4">
        <div class="title">员工信息登记</div>
        <van-form :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">证件信息</div>
          <div class="txt">上传学历证附件</div>
          <van-field name="academicCertificateImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.academicCertificateImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 3)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.academicCertificateImg)" :src="picture.academicCertificateImg"/>
                <i @click="delimg(3)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==5">
        <div class="title">员工信息登记</div>
        <van-form :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>上传介绍信附件</div>
          <van-field name="letterImg" class="noborder" :rules="[{ required: picture.letterImg==''?true:false, message: '请上传介绍信附件' }]">
            <template #input>
              <van-uploader v-if="picture.letterImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 4)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.letterImg)" :src="picture.letterImg"/>
                <i @click="delimg(4)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==6">
        <div class="title">员工信息登记</div>
        <van-form :show-error-message="false" :scroll-to-error="true" @submit="goSubmit5">
          <div class="tmt">其他附件</div>
          <div class="txt">居住证</div>
          <van-field name="residencePermitImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.residencePermitImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 5)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.residencePermitImg)" :src="picture.residencePermitImg"/>
                <i @click="delimg(5)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt">健康宝个人信息自查</div>
          <van-field name="healthCodeImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.healthCodeImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 7)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.healthCodeImg)" :src="picture.healthCodeImg"/>
                <i @click="delimg(7)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt">行程码</div>
          <van-field name="tripCodeImg" class="noborder">
            <template #input>
              <van-uploader v-if="picture.tripCodeImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 8)" multiple :max-count="1" show-upload upload-text="上传附件">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.tripCodeImg)" :src="picture.tripCodeImg"/>
                <i @click="delimg(8)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt">是否接种疫苗</div>
          <van-field name="uploader" class="noborder">
            <template #input>
              <van-radio-group v-model="picture.vaccinesFlag">
                  <van-radio name="0">未接种</van-radio>
                  <van-radio name="1">已接种</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-show="Number(picture.vaccinesFlag==1)">
            <div class="txt">第一次接种时间</div>
            <van-field readonly clickable name="firstVaccinationTime" :value="picture.firstVaccinationTime" placeholder="请选择第一次接种时间" @click="getshowPicker4"/>
                <van-popup v-model="showPicker44" position="bottom">
                <van-datetime-picker
                    v-model="currentDate44"
                    type="date"
                    @confirm="onConfirmtwo44"
                    @cancel="showPicker44 = false"/>
                </van-popup>
            <div class="txt">第二次接种时间</div>
            <van-field readonly clickable name="secondVaccinationTime" :value="picture.secondVaccinationTime" placeholder="请选择第二次接种时间" @click="getshowPicker5"/>
                <van-popup v-model="showPicker45" position="bottom">
                <van-datetime-picker
                    v-model="currentDate45"
                    type="date"
                    @confirm="onConfirmtwo45"
                    @cancel="showPicker45 = false"/>
                </van-popup>
            <div class="txt">第三次接种时间</div>
            <van-field readonly clickable name="thirdVaccinationTime" :value="picture.thirdVaccinationTime" placeholder="请选择第三次接种时间" @click="getshowPicker6"/>
              <van-popup v-model="showPicker46" position="bottom">
              <van-datetime-picker
                  v-model="currentDate46"
                  type="date"
                  @confirm="onConfirmtwo46"
                  @cancel="showPicker46 = false"/>
              </van-popup>
            <div class="txt">疫苗</div>
            <van-field name="vaccinesImg" class="noborder">
              <template #input>
                <van-uploader v-if="picture.vaccinesImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 9)" multiple :max-count="1" show-upload upload-text="上传附件">
                </van-uploader>
                <div class="widbox" v-else>
                  <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.vaccinesImg)" :src="picture.vaccinesImg"/>
                  <i @click="delimg(9)">x</i>
                </div>
              </template>
            </van-field>
            <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          </div>
          <div v-show="Number(picture.vaccinesFlag==0)" class="formfoot"></div>

          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-show="index==7">
        <div class="title">员工信息登记</div>
        <van-form @submit="goSubmit8">
          <div class="tmt">证件信息</div>
          <div class="txt"><i>*</i>1.承诺书（一）</div>
          <van-field name="commitmentOneImg" class="noborder" :rules="[{ required: picture.commitmentOneImg==''?true:false, message: '请上传承诺书（一）' }]">
            <template #input>
              <van-uploader v-if="picture.commitmentOneImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 11)" multiple :max-count="1" show-upload upload-text="承诺书（一）">
              </van-uploader>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.commitmentOneImg)" :src="picture.commitmentOneImg"/>
                <i @click="delimg(11)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss">支持上传jpg、jpeg、png格式</div>
          <div class="txt"><i>*</i>2.承诺书（二）</div>
          <van-field name="commitmentTwoImg" class="noborder" :rules="[{ required: picture.commitmentTwoImg==''?true:false, message: '请上传承诺书（二）' }]">
            <template #input>
              <van-uploader v-if="picture.commitmentTwoImg==''" :before-read="beforeRead" :after-read="(file)=>afterRead(file, 12)"  multiple :max-count="1" show-upload  upload-text="承诺书（二）"/>
              <div class="widbox" v-else>
                <van-image width="100%" height="auto" fit="cover" position="bottom" @click="geshow(picture.commitmentTwoImg)" :src="picture.commitmentTwoImg"/>
                <i @click="delimg(12)">x</i>
              </div>
            </template>
          </van-field>
          <div class="tipss formfoot">支持上传jpg、jpeg、png格式</div>
          <div class="fixdbottom" style="margin: 0.6rem 0;">
            <van-button round block type="primary" @click.prevent="cutindex()">上一步</van-button>
            <van-button round block type="primary" native-type="submit" :loading="loading">下一步</van-button>
          </div>
        </van-form>
      </div>
      <div class="page" v-if="index==8">
        <div class="boximg flexcenter">
          <img src="@/assets/suc.png"/>
          <div class="text" v-if="!guide.documentStatus || guide.documentStatus!=2">
            <div class="btit flexcenter">提交成功</div>
            <p>感谢您的提交，信息将在几日内完成审核，请耐心等待</p>
            <van-button type="primary" style="width:45%" @click.prevent="goindex()">继续填写</van-button>
          </div>
          <div class="text" v-else>
            <div class="btit flexcenter">该导购已通过审核</div>
          </div>
        </div>
      </div>
    </div>
    <div class="showbj" v-if="showloading">
      <van-loading type="spinner" color="white" size="60"/>
    </div>
    <van-popup v-model="show" position="center" :closeable="true" :style="{width:'80%',height: '60%' }">
        <iframe :src="'https://view.xdocin.com/view?src='+guide.electronicContract" style="width: 100%;height: 100%" frameborder="0" />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { ImagePreview } from 'vant'
import html2canvas from 'html2canvas'
import * as imageConversion from 'image-conversion';
export default {
  name: 'Index',
  data () {
    return {
      age:'',
      shopCompany:'',
      show:false,
      loading:false,
      showloading:false,
      type:0,
      signshow:false,
      showsupply:false,
      supply:'',
      showbrand:false,
      brand:'',
      sign1:'',
      checked:false,
      checked1:false,
      sign2:'',
      showimg:false,
      images:[],
      list:[],
      filterList:[],
      filterList2:[],
      brandList:[],
      brandList1:[],
      brandList2:[],
      showPicker:false,
      showPicker1:false,
      showPicker2:false,
      showPicker3:false,
      showPicker4:false,
      showPicker5:false,
      showPicker6:false,
      showPicker7:false,
      showPicker8:false,
      showPicker44:false,
      showPicker45:false,
      showPicker46:false,
      showPicker47:false,
      showPicker48:false,
      showgent:false,
      gentindex:0,
      columns:['101', '102'],
      gentcolumns:['父子/女', '母子/女','兄弟/姐妹','夫妻','其他'],
      columns2:['1-小学', '2-初中', '3-中专', '4-高中', '5-大专', '6-大学', '7-研究生'],
      heightList:[],
      result:'',
      shopSid:'',
      shopName:'',
      mobile:'',
      name:'',
      guide:{},
      documentSource:1,
      familyList:[{
        memberRelation: '',
        memberName: '',
        memberMobile: '',
      }],
      company:{
        position: '',
      },
      picture:{
        idCardFaceImg:'',
        idCardEmblemImg:'',
        healthCertificateImg:'',
        academicCertificateImg:'',
        letterImg:'',
        residencePermitImg:'',
        nucleicAcidImg:'',
        healthCodeImg:'',
        tripCodeImg:'',
        vaccinesImg:'',
        commitmentOneImg:'',
        commitmentTwoImg:'',
        idPhotoImg:'',
      },
      workList:[{
        company: '',
        position: '',
        entryTime: '',
        resignTime: '',
        resignReason: ''
      }],
      certificate:{
        healthCartNo:'',
        healthCartStartTime:'',
        healthCartEndtime:'',
        kitasEndtime:'',
        guideIdType:'1',
      },
      guideSign:{},
      index:0,
      guideNo:'',
      guideSid:'',
      currentDate:new Date(2022, 10, 1),
      minDate: new Date(1942, 0, 1),
      maxDate: new Date(2025, 10, 1),
      maxDate1: new Date(2050, 10, 1),
      currentDate1:'',
      currentDate2:'',
      currentDate3:'',
      currentDate7:'',
      currentDate8:'',
      currentDate44:'',
      currentDate45:'',
      currentDate46:'',
      currentDate47:'',
      currentDate48:'',
      data:'',
      shoplist:[],
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '#ffffff',
      resultImg: '',
      isCrop: false,
      // telRules: [{
      //   validator: value => {
      //       return /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)
      //   },
      //   message: '邮箱格式不正确',
      //   trigger: 'onBlur'
      // }],
      validator:value => {
          return /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)
      },
      telRules2:[{
        required: true,
        message: '请输入手机号',
        trigger: 'onBlur'
      }, {
        validator: value => {
            return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)
        },
        message: '手机号格式不正确',
        trigger: 'onBlur'
      }],
      telRules3:[{
        required: true,
        message: '请输入身份证号',
        trigger: 'onBlur'
      }, {
        validator: value => {
            return /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/.test(value)
        },
        message: '身份证号格式不正确',
        trigger: 'onBlur'
      }]
    }
  },
  created(){
    let url=window.location.href
    console.log(url)
    var temp1 = url.split('?');
    var temp2=temp1[1].split('&')
    if(temp2.length>0){
      this.type=(temp2[0].split('='))[1]
      if(this.type==1){
        let shopSid=(temp2[1].split('='))[1]
        this.shopSid=shopSid.split('#/')[0]
      }
    }
    this.getshop()
    this.getheight()
    this.getnewdata()
  },
  methods:{
    downfile(){
      window.open(this.guide.electronicContract)
    },
    deleteImg() {
      this.guide.electronicContract=''
    },
    beforeRead1(file){
      let that=this;
      that.showloading=true
      console.log('文件上传文件上传',file)
      let name=file.name.split('.')
      if (name[name.length-1] != 'jpg' && name[name.length-1] != 'jpeg' && name[name.length-1] != 'png' && name[name.length-1] != 'pdf' && name[name.length-1] != 'docx') {
          that.$toast('文件格式不正确');
          that.showloading=false
          return false;
      }
      let form = new FormData()
      form.append('annexUrl', file)
      form.append('operator', that.mobile || that.guide.guideMobile)
      that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
        if(res.data.state==200){
          that.guide.electronicContract=res.data.data.accessPath
        }else{
          that.guide.electronicContract=''
          that.$toast(res.data.desc);
        }
        that.showloading=false
        console.log(that.guide.electronicContract)
      }).catch((error) =>{
        that.showloading=false
      });
    },
    afterRead1(file){
    },
    getaddre(e){
      console.log(e)
    },
    goindex(){
      this.index=0
      this.mobile=''
    },
    getshop(){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getAllShopList",'').then((res) => {
        if(res.status==200){
          that.shoplist=res.data.shopList
          if(res.data.shopList.length>0){
            let index = res.data.shopList.findIndex(item => item.value === '100')
            if(index>-1){
              that.shoplist.splice(index, 1)
            }
            if(that.shoplist.length>0 && this.type==1){
              let nindex = that.shoplist.findIndex(item => item.value === that.shopSid)
              that.shopName=that.shoplist[nindex].text
            }
          }
        }
      }).catch((error) =>{
      });

    },
    telRules(val){
      if(val){
        return /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/.test(val);
      }
    },
    getidcard(id){
      var re = /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/;
      if(re.test(id)){
        let birth=id.substring(6, 10) + "-" + id.substring(10, 12) + "-" + id.substring(12, 14);
        var myDate = new Date();
        var age = myDate.getFullYear() - id.substring(6, 10) - 1;
        var sec=id.substring(16,17)
        var sex=sec%2==0?'2':'1'
        var provinces = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外" };
        var province = provinces[parseInt(id.substr(0, 2))];
        this.guide.guideSex=sex
        this.guide.guideBirthday=birth
        this.guide.guideHomeAddr=province
        this.age=age
      }
    },
    set(e){
      let value = e;
      if(!value){
        this.filterList = this.list;
        return;
      }

      let filterArr = [];
      let filterArr2 = [];
      // 过滤出符合条件的值
      this.list.forEach((item,index)=>{
        if(item.name.includes(value)){
          let m={
            value:item.value,
            name:this.join(item.name,value)
          }
          let nlist={
            value:item.value,
            name:item.name
          }
          filterArr2.push(nlist)
          filterArr.push(m);
        }
      });
      this.filterList = filterArr;
      this.filterList2 = filterArr2;
    },
    setbrand(e){
      let value = e;
      if(!value){
        this.brandList1 = this.brandList;
        return;
      }
      let brandList1 = [];
      let brandList2 = [];
      // 过滤出符合条件的值
      this.brandList.forEach((item,index)=>{
        if(item.name.includes(value)){
          let m={
            value:item.value,
            name:this.join(item.name,value)
          }
          let nlist={
            value:item.value,
            name:item.name
          }
          brandList1.push(m);
          brandList2.push(nlist)
        }
      });
      this.brandList1 = brandList1;
      this.brandList2 = brandList2;
    },
			// 拼接
    join(str,key){
      var reg = new RegExp((`(${key})`), "gm");
      var replace = '<span style="color:#0096FF;font-weight:bold;">$1</span>';
      return str.replace(reg, replace);
    },
    getheight() {
      for (let i = 150; i <= 180; i++) {
        this.heightList.push(i)
      }
    },
    getbrand(){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getBaseMainData/"+that.shopSid+'?supplySid='+that.company.companySid).then((res) => {
        if(res.status==200){
          that.brandList=res.data.data.brandList
          that.brandList1=res.data.data.brandList
          that.brandList2=res.data.data.brandList
        }
      }).catch((error) =>{
      });
    },
    getshowbrand(){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      this.showbrand=true
    },
    gobrand(index){
      this.company.brand=this.brandList2[index].name
      this.company.brandSid=this.brandList2[index].value
      this.showbrand=false
    },
    getsupply(){
      let that=this;
      that.$axios.get(process.env.API_HOST+"api/vue/mainData/shop/getBaseMainData/"+that.shopSid).then((res) => {
        if(res.status==200){
          that.list=res.data.data.supplyList
          that.filterList=res.data.data.supplyList
          that.filterList2=res.data.data.supplyList
        }
      }).catch((error) =>{
      });
    },
    getshowsupply(){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      this.showsupply=true
    },
    gosupply(index){
      this.company.company=this.filterList2[index].name
      this.company.companySid=this.filterList2[index].value
      this.getbrand()
      this.showsupply=false
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    getsignshow(){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      this.signshow=true
    },
    handleGenerate () { // 获取base64
      let that=this
      that.showloading=true
      that.$refs.esign.generate('',10).then((res) => {
        var blob = that.dataURLtoBlob(res)
        var tofile = that.blobToFile(blob, '签名.png')
        if(that.index==10){
          that.sign1=res
          blob = that.dataURLtoBlob(res)
          tofile = that.blobToFile(blob, '签名.png')
        }else if(that.index==11){
          that.sign2=res
          blob = that.dataURLtoBlob(res)
          tofile = that.blobToFile(blob, '签名.png')
        }
        setTimeout(async () => {
            let form = new FormData()
            form.append('annexUrl', tofile, tofile.name)
            form.append('operator', that.mobile || that.guide.guideMobile)
            form.append('fileType', 9)
            that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
              if(res.status==200){
                if(that.index==10){
                  that.picture.commitmentSignOneImg=res.data.data.accessPath
                  let form={
                    picture:{
                      sid:that.picture.sid,
                      commitmentSignOneImg:that.picture.commitmentSignOneImg?that.picture.commitmentSignOneImg:'',
                    },
                    guideSid:that.guide.sid,
                    guideNo:that.guide.guideNo
                  }
                  that.getedit(form,true)
                  that.$refs.esign.reset()
                }else if(that.index==11){
                  that.picture.commitmentSignTwoImg=res.data.data.accessPath
                  let form={
                    picture:{
                      sid:that.picture.sid,
                      commitmentSignTwoImg:that.picture.commitmentSignTwoImg?that.picture.commitmentSignTwoImg:'',
                    },
                    guideSid:that.guide.sid,
                    guideNo:that.guide.guideNo
                  }
                  that.getedit(form,true)
                  that.$refs.esign.reset()
                }
              }
            }).catch((error) =>{});
          }, 800)
        that.signshow=false
      }).catch((err) => {
      });
    },
    // 将base64转换为blob
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    download(index) {
      let that=this;
      const ref = that.$refs.faultTree // 截图区域
      html2canvas(ref, { backgroundColor: '#fff' }).then(canvas => {
        const dataURL = canvas.toDataURL('image/png')
        var blob = that.dataURLtoBlob(dataURL)
        var tofile = that.blobToFile(blob, '签名.png')
        setTimeout(async () => {
          let form = new FormData()
          form.append('annexUrl', tofile, tofile.name)
          form.append('operator', that.mobile || that.guide.guideMobile)
          form.append('fileType', 9)
          that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
            if(res.status==200){
              if(index==10){
                that.picture.commitmentOneImg=res.data.data.accessPath
                let form={
                  picture:{
                    sid:that.picture.sid,
                    commitmentOneImg:that.picture.commitmentOneImg?that.picture.commitmentOneImg:'',
                  },
                  guideSid:that.guide.sid,
                  guideNo:that.guide.guideNo
                }
                that.getedit(form)
              }else if(index==11){
                that.picture.commitmentTwoImg=res.data.data.accessPath
                let form={
                  picture:{
                    sid:that.picture.sid,
                    commitmentTwoImg:that.picture.commitmentTwoImg?that.picture.commitmentTwoImg:'',
                  },
                  guideSid:that.guide.sid,
                  guideNo:that.guide.guideNo,
                  submitFlag:1,
                }
                that.getedit(form)
              }
            }
          }).catch((error) =>{});
        }, 500)
      })
    },
    getnewdata(){
      let nowDate = new Date();
      let month= nowDate.getMonth() + 1;
      let date = {
        year: nowDate.getFullYear(),
        month:month<10? '0'+month:month,
        date: nowDate.getDate()<10?'0'+nowDate.getDate():nowDate.getDate(),
      }
      this.data = date.year + " 年 "+date.month +" 月 "+ date.date+" 日";
    },
    cutindex(){
      let that=this;
      if(Number(that.certificate.guideIdType)==2 && that.index==6 && that.type==1){
        that.index=that.index-2
      }else if(Number(that.certificate.guideIdType)==2 && that.index==3 && that.type==2){
        that.index=that.index-2
      }else{
        that.index=that.index-1
      }

    },
    delimg(index){
      if(index==0){
        this.picture.idCardFaceImg=''
      }else if(index==1){
        this.picture.idCardEmblemImg=''
      }else if(index==2){
        this.picture.healthCertificateImg=''
      }else if(index==3){
        this.picture.academicCertificateImg=''
      }else if(index==4){
        this.picture.letterImg=''
      }else if(index==5){
        this.picture.residencePermitImg=''
      }else if(index==6){
        this.picture.nucleicAcidImg=''
      }else if(index==7){
        this.picture.healthCodeImg=''
      }else if(index==8){
        this.picture.tripCodeImg=''
      }else if(index==9){
        this.picture.vaccinesImg=''
      }else if(index==10){
        this.picture.idPhotoImg=''
      }else if(index==11){
        this.picture.commitmentOneImg=''
      }else if(index==12){
        this.picture.commitmentTwoImg=''
      }else if(index==13){
        this.guide.electronicContract=''
      }
    },
    geshow(img){
      ImagePreview({
        images: [img],
        startPosition: 0,
        onClose() {
        }
      })
    },
    delfamily(index){
      this.familyList.splice(index,1)
    },
    addfamily(){
      let item={
        memberRelation: '',
        memberName: '',
        memberMobile: '',
      }
      this.familyList.push(item)
    },
    delwork(index){
      this.workList.splice(index,1)
    },
    addwork(){
      let item={
        company: '',
        position: '',
        entryTime: '',
        resignTime: '',
        resignReason: ''
      }
      this.workList.push(item)
    },
    beforeRead(file){
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$toast('图片格式不正确');
        return false;
      }
      return new Promise((resolve) => {
          imageConversion.compressAccurately(file, 100).then(res => {
              resolve(res);
          });
      })
    }, 
    /* base64转Blob对象 */
    dataURItoBlob(data) {
        let byteString
        if (data.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(data.split(',')[1])
        } else {
            byteString = unescape(data.split(',')[1])
        }
        const mimeString = data.split(',')[0].split(':')[1].split(';')[0]
        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i += 1) {
            ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ia], { type: mimeString })
    },
    afterRead(file,index){
      let that=this
      that.showloading=true
      let form = new FormData()
      var tofile=''
      if(file.file.lastModified && file.file.lastModified!=''){

      }else{
        tofile = that.blobToFile(file.file, '签名.png')
      }
      if(file.file.lastModified && file.file.lastModified!=''){
        form.append('annexUrl', file.file)
        form.append('operator', that.mobile || that.guide.guideMobile)
      }else{
        form.append('annexUrl', tofile, tofile.name)
        form.append('operator', that.mobile || that.guide.guideMobile)
        form.append('fileType', 9)
      }
      that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/image",form).then((res) => {
        if(res.data.state==200){
          if(index==0){
            that.picture.idCardFaceImg=res.data.data.accessPath
          }else if(index==1){
            that.picture.idCardEmblemImg=res.data.data.accessPath
          }else if(index==2){
            that.picture.healthCertificateImg=res.data.data.accessPath
          }else if(index==3){
            that.picture.academicCertificateImg=res.data.data.accessPath
          }else if(index==4){
            that.picture.letterImg=res.data.data.accessPath
          }else if(index==5){
            that.picture.residencePermitImg=res.data.data.accessPath
          }else if(index==6){
            that.picture.nucleicAcidImg=res.data.data.accessPath
          }else if(index==7){
            that.picture.healthCodeImg=res.data.data.accessPath
          }else if(index==8){
            that.picture.tripCodeImg=res.data.data.accessPath
          }else if(index==9){
            that.picture.vaccinesImg=res.data.data.accessPath
          }else if(index==10){
            that.picture.idPhotoImg=res.data.data.accessPath
          }else if(index==11){
            that.picture.commitmentOneImg=res.data.data.accessPath
          }else if(index==12){
            that.picture.commitmentTwoImg=res.data.data.accessPath
          }else if(index==13){
            that.guide.electronicContract=res.data.data.accessPath
          }
          
        }else{
          that.$toast(res.data.desc);
          if(index==0){
            that.picture.idCardFaceImg=''
          }else if(index==1){
            that.picture.idCardEmblemImg=''
          }else if(index==2){
            that.picture.healthCertificateImg=''
          }else if(index==3){
            that.picture.academicCertificateImg=''
          }else if(index==4){
            that.picture.letterImg=''
          }else if(index==5){
            that.picture.residencePermitImg=''
          }else if(index==6){
            that.picture.nucleicAcidImg=''
          }else if(index==7){
            that.picture.healthCodeImg=''
          }else if(index==8){
            that.picture.tripCodeImg=''
          }else if(index==9){
            that.picture.vaccinesImg=''
          }else if(index==10){
            that.picture.idPhotoImg=''
          }else if(index==11){
            that.picture.commitmentOneImg=''
          }else if(index==12){
            that.picture.commitmentTwoImg=''
          }else if(index==13){
            that.guide.electronicContract=''
          }
        }
        that.showloading=false
      }).catch((error) =>{
        that.showloading=false
      });

    },
    onSubmit(values){
      let that=this
      that.loading=true
      that.$axios.get(process.env.API_HOST+"sysmanager/vue/guide/queryGuideDetailByMobile/"+that.shopSid+'/'+that.mobile).then((res) => {
          that.loading=false
          if(res.data.state==200){
            if(res.data.data.guide.status==2){
              if(that.type==2){
                this.$toast('导购已注销');
              }else{
                that.guide={
                  guideIdType:'1',
                  guideSex:'2',
                  guideMobile:that.mobile
                }
                that.certificate.guideIdType='1'
                that.index++
              }
            }else{
              that.shopCompany=res.data.data.shopCompany || ''
              that.guide=res.data.data.guide
              that.guide.electronicContract=res.data.data.picture && res.data.data.picture.electronicContract!='' && res.data.data.picture.electronicContract!=null?res.data.data.picture.electronicContract:''
              that.documentSource==res.data.data.guide.documentSource
              that.familyList=res.data.data.familyList!=null && res.data.data.familyList.length!=0?res.data.data.familyList:[{
                memberRelation: '',
                memberName: '',
                memberMobile: '',
              }]
              that.company={
                company:res.data.data.company!=null && res.data.data.company.company!=null?res.data.data.company.company:'',
                brand:res.data.data.company!=null && res.data.data.company.brand!=null?res.data.data.company.brand:'',
                position:res.data.data.company!=null && res.data.data.company.position!=null?res.data.data.company.position:'',
                sid:res.data.data.company!=null && res.data.data.company.sid,
              }
              that.picture=res.data.data.picture
              
              that.workList=res.data.data.workList!=null && res.data.data.workList.length!=0?res.data.data.workList:[{
                company: '',
                position: '',
                entryTime: '',
                resignTime: '',
                resignReason: ''
              }]
              that.guideSign=res.data.data.guideSign
              that.guideNo=res.data.data.guideNo
              // that.guideSid=res.data.data.guide.sid
              that.guideSid=res.data.data.guide.sid

              that.certificate=res.data.data.certificate
              that.certificate.guideIdType=res.data.data.certificate.guideIdType==null?'1':res.data.data.certificate.guideIdType.toString()
              that.certificate.healthCartNo=that.certificate.healthCartNo!=null?that.certificate.healthCartNo:''
              that.certificate.healthCartStartTime=that.certificate.healthCartStartTime!=null?that.certificate.healthCartStartTime:''
              that.certificate.healthCartEndtime=that.certificate.healthCartEndtime!=null?that.certificate.healthCartEndtime:''
              that.certificate.kitasEndtime=that.certificate.kitasEndtime!=null?that.certificate.kitasEndtime:''
              that.certificate.residencePermitNo=that.certificate.residencePermitNo!=null?that.certificate.residencePermitNo:''
              that.certificate.sid=res.data.data.certificate.sid!=null?res.data.data.certificate.sid:'',
              that.guide.educationCodeName=that.columns2[Number(that.guide.educationCode)-1]
              let picture=res.data.data.picture
              that.picture={
                academicCertificateImg:picture!=null && picture.academicCertificateImg?picture.academicCertificateImg:'',
                commitmentOneImg:picture!=null && picture.commitmentOneImg?picture.commitmentOneImg:'',
                commitmentTwoImg:picture!=null && picture.commitmentTwoImg?picture.commitmentTwoImg:'',
                healthCertificateImg:picture!=null && picture.healthCertificateImg?picture.healthCertificateImg:'',
                healthCodeImg:picture!=null && picture.healthCodeImg?picture.healthCodeImg:'',
                idCardEmblemImg:picture!=null && picture.idCardEmblemImg?picture.idCardEmblemImg:'',
                idCardFaceImg:picture!=null && picture.idCardFaceImg?picture.idCardFaceImg:'',
                idPhotoImg:picture!=null && picture.idPhotoImg?picture.idPhotoImg:'',
                letterImg:picture!=null && picture.letterImg?picture.letterImg:'',
                nucleicAcidImg:picture!=null && picture.nucleicAcidImg?picture.nucleicAcidImg:'',
                residencePermitImg:picture!=null && picture.residencePermitImg?picture.residencePermitImg:'',
                tripCodeImg:picture!=null && picture.tripCodeImg?picture.tripCodeImg:'',
                vaccinesImg:picture!=null && picture.vaccinesImg?picture.vaccinesImg:'',
                commitmentSignOneImg:picture!=null && picture.commitmentSignOneImg?picture.commitmentSignOneImg:'',
                commitmentSignTwoImg:picture!=null && picture.commitmentSignTwoImg?picture.commitmentSignTwoImg:'',
                sid:picture!=null && picture.sid?picture.sid:'',
                vaccinesFlag:picture!=null && picture.vaccinesFlag?picture.vaccinesFlag.toString():'0',
                firstVaccinationTime:picture!=null && picture.firstVaccinationTime?picture.firstVaccinationTime:'',
                secondVaccinationTime:picture!=null && picture.secondVaccinationTime?picture.secondVaccinationTime:'',
                thirdVaccinationTime:picture!=null && picture.thirdVaccinationTime?picture.thirdVaccinationTime:'',
                electronicContract:that.guide.electronicContract?that.guide.electronicContract:'',
              }
              that.checked=picture!=null && picture.commitmentOneImg?true:false
              that.checked1=picture!=null && picture.commitmentTwoImg?true:false
              that.age=that.guide.guideBirthday!='' && that.guide.guideBirthday!=null?that.getages1(that.guide.guideBirthday):that.guide.guideIdType==1?that.getages(that.guide.guideIdCard):''
              that.index=1
            }

          }else{
            if(res.data.errorCode=='SYSTEM0008'){
              that.guide={
                guideSex:'2',
                guideMobile:that.mobile,
                guideHomeAddr:'',
              }
              that.certificate.guideIdType='1'
              that.picture.vaccinesFlag='1'
              that.index++
            }else{
              this.$toast(res.data.message);
            }
          }
        }).catch((error) =>{
          that.loading=false
        });
    },
    //提交用户信息
    goSubmit(values){
      let that=this
      that.loading=true
      let form={}
      if(!that.guide.sid || that.guide.sid==''){
        form=that.guide
        form.guideIdCard=Number(that.certificate.guideIdType)==1?that.guide.guideIdCard:''
        form.guideHomeAddr=Number(that.certificate.guideIdType)==1?that.guide.guideHomeAddr:''
        form.guideIdType=that.certificate.guideIdType
        form.guidePassportNo=Number(that.certificate.guideIdType)==2?that.certificate.guidePassportNo:''
        form.guidePassportStartTime=Number(that.certificate.guideIdType)==2?that.certificate.guidePassportStartTime:''
        form.guidePassportEndTime=Number(that.certificate.guideIdType)==2?that.certificate.guidePassportEndTime:''
        form.idPhotoImg=that.picture.idPhotoImg?that.picture.idPhotoImg:'',
        form.shopSid=that.shopSid
        form.documentSource=that.documentSource
      }else{
        form={
          guide:that.guide,
          certificate:{
            guideIdType:that.certificate.guideIdType,
            guidePassportNo:Number(that.certificate.guideIdType)==2?that.certificate.guidePassportNo:'',
            guidePassportStartTime:Number(that.certificate.guideIdType)==2?that.certificate.guidePassportStartTime:'',
            guidePassportEndTime:Number(that.certificate.guideIdType)==2?that.certificate.guidePassportEndTime:'',
            sid:that.certificate.sid,
            guideIdCard:that.guide.guideIdCard,
            guideIdType:that.certificate.guideIdType,
            guidePassportEndTime:that.certificate.guidePassportEndTime,
            guidePassportStartTime:that.certificate.guidePassportStartTime,
            guidePassportNo:that.certificate.guidePassportNo,
          },
          picture:{
            idPhotoImg:that.picture.idPhotoImg?that.picture.idPhotoImg:'',
            sid:that.picture.sid
          },
          guideSid:that.guideSid
        }
        form.guide.guideIdCard=Number(that.certificate.guideIdType)==1?that.guide.guideIdCard:''
        form.guide.guideHomeAddr=Number(that.certificate.guideIdType)==1?that.guide.guideHomeAddr:''
      }
      that.getsupply()
      that.getedit(form)
    },
    goSubmit2(values){
      let that=this
      that.loading=true
      let form={
        employer:that.company,
        guide:that.guide,
        guideSid:that.guideSid
      }
      form.employer.sid=that.company.sid,
      that.getedit(form)
    },
    goSubmit3(values){
      let that=this
      that.loading=true
      let form={
        familyList:that.familyList,
        guideSid:that.guide.sid,
        guideNo:that.guide.guideNo,
        guideSid:that.guideSid
      }
      that.getedit(form)

    },
    goSubmit4(values){
      let that=this
      that.loading=true
      let form={
        workList:that.workList,
        guideSid:that.guide.sid,
        guideNo:that.guide.guideNo,
      }
      that.getedit(form)
    },
    goSubmit5(value){
      let that=this;
      that.loading=true
      let form={
        picture:{
          academicCertificateImg:that.picture.academicCertificateImg?that.picture.academicCertificateImg:'',
          commitmentOneImg:that.picture.commitmentOneImg?that.picture.commitmentOneImg:'',
          commitmentTwoImg:that.picture.commitmentTwoImg?that.picture.commitmentTwoImg:'',
          healthCertificateImg:that.picture.healthCertificateImg?that.picture.healthCertificateImg:'',
          healthCodeImg:that.picture.healthCodeImg?that.picture.healthCodeImg:'',
          idCardEmblemImg:Number(that.certificate.guideIdType)==1 && that.picture.idCardEmblemImg?that.picture.idCardEmblemImg:'',
          idCardFaceImg:Number(that.certificate.guideIdType)==1 && that.picture.idCardFaceImg?that.picture.idCardFaceImg:'',
          idPhotoImg:that.picture.idPhotoImg?that.picture.idPhotoImg:'',
          letterImg:that.picture.letterImg?that.picture.letterImg:'',
          nucleicAcidImg:that.picture.nucleicAcidImg?that.picture.nucleicAcidImg:'',
          residencePermitImg:that.picture.residencePermitImg?that.picture.residencePermitImg:'',
          tripCodeImg:that.picture.tripCodeImg?that.picture.tripCodeImg:'',
          vaccinesImg:that.picture.vaccinesImg?that.picture.vaccinesImg:'',
          sid:that.picture.sid?that.picture.sid:'',
          vaccinesFlag:that.picture.vaccinesFlag?that.picture.vaccinesFlag:'',
          firstVaccinationTime:that.picture.firstVaccinationTime?that.picture.firstVaccinationTime:'',
          secondVaccinationTime:that.picture.secondVaccinationTime?that.picture.secondVaccinationTime:'',
          thirdVaccinationTime:that.picture.thirdVaccinationTime?that.picture.thirdVaccinationTime:'',
          electronicContract:that.guide.electronicContract?that.guide.electronicContract:'',
        },
        guideSid:that.guide.sid,
        guideNo:that.guide.guideNo
      }
      that.getedit(form)
    },
    goSubmit6(value){
      let that=this;
      that.loading=true
      let form={
        certificate:{
          healthCartEndtime:that.certificate.healthCartEndtime,
          healthCartNo:that.certificate.healthCartNo,
          healthCartStartTime:that.certificate.healthCartStartTime,
          kitasEndtime:that.certificate.kitasEndtime,
          residencePermitNo:that.certificate.residencePermitNo,
          sid:that.certificate.sid,
          guideIdCard:that.guide.guideIdCard,
          guideIdType:that.certificate.guideIdType,
          guidePassportEndTime:that.certificate.guidePassportEndTime,
          guidePassportStartTime:that.certificate.guidePassportStartTime,
          guidePassportNo:that.certificate.guidePassportNo,
        },
        picture:{
          sid:that.picture.sid,
          healthCertificateImg:that.picture.healthCertificateImg?that.picture.healthCertificateImg:'',
        },
        guideSid:that.guide.sid,
        guideNo:that.guide.guideNo
      }
      that.getedit(form)
    },
    goSubmit7(value){
      let that=this;
      that.loading=true
      let form={
        picture:{
          sid:that.picture.sid,
          academicCertificateImg:that.picture.academicCertificateImg?that.picture.academicCertificateImg:'',
        },
        guideSid:that.guide.sid,
        guideNo:that.guide.guideNo
      }
      that.getedit(form)
    },
    goSubmit8(value){
      let that=this;
      that.loading=true
      let form={
        picture:{
          commitmentOneImg:that.picture.commitmentOneImg?that.picture.commitmentOneImg:'',
          commitmentTwoImg:that.picture.commitmentTwoImg?that.picture.commitmentTwoImg:'',
          sid:that.picture.sid?that.picture.sid:'',
        },
        guideSid:that.guide.sid,
        guideNo:that.guide.guideNo
      }
      that.getedit(form)
    },
    getsubmit(){
      if(this.sign1=='' && (!this.picture.commitmentOneImg || this.picture.commitmentOneImg=='' || this.picture.commitmentOneImg==null)){
        this.$toast('请承诺人先签字');
        return
      }else if(!this.checked){
        this.$toast('请先勾选本人已阅读协议并签字');
        return
      }else{
        if(this.sign1!=''){
          this.showloading=true
          this.loading=true
          this.showloading=true
          this.download(10)
        }else{
          this.loading=false
          this.showloading=false
          this.index++
        }
      }
    },
    getsubmit2(){
      if(this.sign2=='' && (!this.picture.commitmentTwoImg || this.picture.commitmentTwoImg=='' || this.picture.commitmentTwoImg==null)){
        this.$toast('请承诺人先签字');
        return
      }else if(!this.checked1){
        this.$toast('请先勾选本人已阅读协议并签字');
        return
      }else{
        if(this.sign2!=''){
          this.loading=true
          this.download(11)
        }else{
          this.loading=false
          this.index++
        }
      }
    },
    getedit(form,data){
      let that=this
      that.guide.shopSid=that.shopSid
      var re = /^\d{6}(((19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}([0-9]|x|X))|(\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}))$/;
      // if(Number(that.certificate.guideIdType)==1 && that.guide.guideIdCard!='' && !re.test(that.guide.guideIdCard)){
      //     that.$toast('身份证格式有误');
      //     return
      // }else{
      if(that.guide.documentStatus && that.guide.documentStatus==2 && that.type==1 && that.index!=6){
        that.index++
        that.showloading=false
        that.loading=false
        return
      }
        if(!that.guide.sid || that.guide.sid==''){
          that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/createGuide",form).then((res) => {
            that.loading=false
            if(res.data.state==200){
              if(!data){
                if(this.type==1 && this.shopSid==21012 && this.index==7){
                  this.index=9
                }else if(this.type==2 && this.shopSid==21012 && this.index==4){
                  this.index=6
                }else{
                  that.index++
                }
              }
              that.guide=res.data.data.guide
              that.guideSid=res.data.data.guide.sid
              that.picture.sid=res.data.data.picture.sid
              that.company.sid=res.data.data.company.sid
              that.certificate.sid=res.data.data.certificate.sid
              that.certificate.guideIdType=res.data.data.certificate.guideIdType.toString()
              that.certificate.guidePassportNo=res.data.data.certificate.guidePassportNo
              that.certificate.guidePassportStartTime=res.data.data.certificate.guidePassportStartTime
              that.certificate.guidePassportEndTime=res.data.data.certificate.guidePassportEndTime
              that.shopCompany=res.data.data.shopCompany || ''
              that.age=that.guide.guideBirthday!='' && that.guide.guideBirthday!=null?that.getages1(that.guide.guideBirthday):that.guide.guideIdType==1?that.getages(that.guide.guideIdCard):''
            }else{
              that.$toast(res.data.message);
            }
            that.showloading=false
          }).catch((error) =>{
            that.loading=false
            that.showloading=false
          });
        }else{
          form.updatedUser=that.mobile
          form.updatedUserName=that.mobile
          that.$axios.post(process.env.API_HOST+"sysmanager/vue/guide/appletSaveGuide",form).then((res) => {
            that.loading=false
            that.showloading=false
            that.age=that.guide.guideBirthday!='' && that.guide.guideBirthday!=null?that.getages1(that.guide.guideBirthday):that.guide.guideIdType==1?that.getages(that.guide.guideIdCard):''
            if(res.data.state==200){
              this.certificate.guidePassportNo=Number(that.certificate.guideIdType)==2?that.certificate.guidePassportNo:'',
              this.certificate.guidePassportStartTime=Number(that.certificate.guideIdType)==2?that.certificate.guidePassportStartTime:''
              this.certificate.guidePassportEndTime=Number(that.certificate.guideIdType)==2?that.certificate.guidePassportEndTime:''
              if(!data){
                if(Number(that.certificate.guideIdType)==2 && that.index==4 && that.type==1){
                  that.index=6
                }else if(Number(that.certificate.guideIdType)==2 && that.index==1 && that.type==2){
                  that.index=3
                }else{
                  // that.index++
                  if(this.type==1 && this.shopSid==21012 && this.index==7){
                    this.index=9
                  }else if(this.type==2 && this.shopSid==21012 && this.index==4){
                    this.index=6
                  }else{
                    that.index++
                  }
                }
              }
            }else{
              that.$toast(res.data.message);
            }
            console.log("年龄",that.age)
          }).catch((error) =>{
            that.showloading=false
            that.loading=false
          });
        }
      // }
    },
    getages(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - id.substring(6, 10); 
      return age
    },
    getages1(id){
      let myDate = new Date(); 
      let age = myDate.getFullYear() - moment(id).format('YYYY'); 
      return age
    },
    getshowgent(index){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      this.gentindex=index
      this.showgent=true
    },
    onConfirmgent(value){
      this.familyList[this.gentindex].memberRelation=value
      this.showgent=false
    },
    onConfirm (value){
      this.shopName=value.text
      this.shopSid=value.value
      this.showPicker=false
    },
    onConfirm2(value,index){
      this.guide.educationCodeName=value
      this.guide.educationCode=index+1
      this.showPicker2=false
    },
    onConfirm3(value){
      this.guide.height=value
      this.showPicker3=false
    },
    getshowPicker(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate=new Date(year,Month,day)
      this.showPicker1=true
    },
    onConfirmtwo(time) {
        this.guide.guideBirthday=this.getDate(time);
        this.showPicker1 = false;
    },
    getshowPicker1(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate1=new Date(year,Month,day)
      this.showPicker4=true

    },
    onConfirmtwo1(time){
      this.certificate.healthCartStartTime=this.getDate(time);
      this.showPicker4 = false;
    },
    getshowPicker2(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate2=new Date(year,Month,day)
      this.showPicker5=true

    },
    onConfirmtwo2(time){
      this.certificate.healthCartEndtime=this.getDate(time);
      this.showPicker5 = false;
    },
    getshowPicker3(){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate3=new Date(year,Month,day)
      this.showPicker6=true
    },
    onConfirmtwo3(time){
      this.certificate.kitasEndtime=this.getDate(time);
      this.showPicker6 = false;
    },
    getshowPicker4(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate44=new Date(year,Month,day)
      this.showPicker44=true
    },
    onConfirmtwo44(time){
      this.picture.firstVaccinationTime=this.getDate(time);
      this.showPicker44 = false;
    },
    getshowPicker5(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate45=new Date(year,Month,day)
      this.showPicker45=true
    },
    onConfirmtwo45(time){
      this.picture.secondVaccinationTime=this.getDate(time);
      this.showPicker45 = false;
    },
    getshowPicker6(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate46=new Date(year,Month,day)
      this.showPicker46=true
    },
    onConfirmtwo46(time){
      this.picture.thirdVaccinationTime=this.getDate(time);
      this.showPicker46 = false;
    },
    getshowPicker7(){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate7=new Date(year,Month,day)
      this.showPicker7=true

    },
    onConfirmtwo7(item){
      item.entryTime = this.getDate(this.currentDate7);
      this.showPicker7 = false;
    },
    getshowPicker8(){
      if(this.type==1 && this.guide.documentStatus && this.guide.documentStatus==2) return
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate8=new Date(year,Month,day)
      this.showPicker8=true

    },
    onConfirmtwo8(item){
      item.resignTime = this.getDate(this.currentDate8);
      this.showPicker8 = false;
    },
    getshowPicker47(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate47=new Date(year,Month,day)
      this.showPicker47=true
    },
    onConfirmtwo47(time){
      this.certificate.guidePassportStartTime=this.getDate(time);
      this.showPicker47 = false;
    },
    getshowPicker48(){
      let myDate = new Date();
      let year = myDate.getFullYear();
      let Month = myDate.getMonth()
      let day=myDate.getDate()
      this.currentDate48=new Date(year,Month,day)
      this.showPicker48=true
    },
    onConfirmtwo48(time){
      this.certificate.guidePassportEndTime=this.getDate(time);
      this.showPicker48 = false;
    },
    getDate(date){
        var time = new Date(date);
        var year= time.getFullYear()  //年
        var month = ("0" + (time.getMonth() + 1)).slice(-2); //月
        var day = ("0" + time.getDate()).slice(-2); //日
        var mydate = year + "-" + month + "-" + day;
        return mydate
    },
  },
}
</script>

<style scoped>
.page{
  box-sizing: border-box;
  padding: 0 0.4rem 0;
  /* padding: 0 0.4rem 90px; */
}
canvas{
  width: 50vh !important;
}
.formfoot{
  padding-bottom:100px;
}
.page .title{
    font-size: 20px;
		color: #0096FF;
		font-weight: 600;
    margin: 1rem 0.5rem;
    text-align: center;
}
.tit{
  font-size: 14px;
  color: #0096FF;
  font-weight: 600;
  margin: 0.4rem 0 0.3rem;
}
.tmt{
  font-size: 16px;
  margin: 0.4rem 0;
  border-left: 3px solid #0096FF;
  box-sizing: border-box;
  padding-left: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tmt img{
  width: 0.7rem;
  height: 0.7rem;
  box-sizing: border-box;
  padding: 0.1rem;
}
.txt{
  font-size: 14px;
  margin: 0.4rem 0 0.3rem;
}
.txt i{
  color: red;
  font-size: 18px;
  font-style: normal;
  margin-right: 5px;
  position: relative;
  top: 3px;
}
.fixdbottom{
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 20px;
  left: 0;
}
.btn{
   width: 100%;
    box-sizing: border-box;
    padding: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btn .van-button{
  width: 45%;
}
.fixdbottom .van-button{
  width: 48%;
}
.promise{
  padding: 0;
}
.promise .protit{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  box-sizing: border-box;
  padding: 0.9rem 0.4rem 0.7rem;
}
.promise .probox{
  padding: 0 0.4rem;
}
.promise p{
  font-size: 18px;
  margin: 0 0 5px;
  line-height: 160%;
}
.promise img{
  width: 135px;
  display: block;
  margin: 10px 0 20px 2em;
}
.prodate{
  text-align: right;
  box-sizing: border-box;
  padding-bottom: 0.7rem;
}
.indent{
  text-indent: 2em;
}
.widbox{
  position: relative;
}
.widbox i{
  position: absolute;
  top: 0;
  right: 0;
  font-style: normal;
  font-size: 14px;
  border-radius: 0 0 0 12px;
  background: rgba(0, 0, 0, .7);
  text-align: center;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  line-height: 22px;
  color: #fff;
}
.flexcenter{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.boximg{
  box-sizing: border-box;
  padding: 90px 25px;
}
.boximg img{
  width: 90px;
  height: 90px;
  margin-bottom: 20px;
}
.boximg .btit{
  font-size: 24px;
  font-weight: bold;
}
.boximg p{
  line-height: 160%;
  font-size: 18px;
  text-align: center;
}
.boximg .text{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.van-button--primary{
  background-color: #0096FF;
  border-color: #0096FF;
}
.van-cell-group--inset{
  margin: 0;
  border:1px solid #ebedf0;
  border-radius: 0.1rem;
}
.van-cell-group--inset .van-cell{
  border: none;
}
.van-cell{
  border:1px solid #ebedf0;
  border-radius: 0.1rem;
}
.foot .van-button{
  margin: 20px 0;
}
.foot .van-checkbox{
  margin: 30px 0;
}
.tipss{
  color: rgba(69,90,100,.6);
  font-size: 14px;
}
>>>.van-search{
  position: fixed;
  top: 40%;
  left: 0;
  width: 100%;
  z-index: 999;
}
>>> .van-search__content{
  padding-left: 0;
}
>>> .van-list{
  position: absolute;
  top: 1.5rem;
  left: 0;
  width: 100%;
}
>>> .van-search .van-cell{
  padding-left: 12px;
}
>>> .van-cell::after,>>> .van-hairline--top-bottom::after, >>> .van-hairline-unset--top-bottom::after,.noborder{
  border: none;
}
>>> .van-checkbox__label{
  font-size: 18px;
}
>>> .van-checkbox__icon .van-icon{
  border-radius: 4px;
}
.esignTest{
  width: 100%;
  height: 100%;
}
>>> .van-field__control{
  display: block;
  width: 100%;
}
>>> .van-radio-group{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
>>> .van-radio+.van-radio{
  margin-left:10px;
}
>>> .van-uploader{
  width: 100%;
}
>>> .van-uploader__wrapper{
  width: 100%;
  height: 0;
  padding-top: 60.2%;
  box-sizing: border-box;
  margin: 0;
}
>>> .van-uploader__upload{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
}
>>> .van-button--disabled{
  opacity: .3;
}
/* .zm >>>.van-uploader__upload{
  background: url('http://116.196.116.98:4869/52193ed8a175ad5dcd07fbf227cdee59?f=png') no-repeat center;
  background-size:contain;
}
.fm >>>.van-uploader__upload{
  background: url('http://116.196.116.98:4869/35b620480fcefb70d8674d447bb54691?f=png') no-repeat center;
  background-size:contain;
} */
/* .zm >>>.van-uploader__upload-icon,.zm >>>.van-uploader__upload-text,.fm >>>.van-uploader__upload-icon,.fm >>>.van-uploader__upload-text{
  display: none;
} */
>>> .van-radio__label--disabled{
  color: #323233;
}
>>> .van-radio__icon--disabled .van-icon{
  background-color: #fff;
}
>>> .van-radio__icon--checked .van-icon{
      color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
>>> .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
}
>>> .van-checkbox__label--disabled{
  color: #323233;
}
>>> .van-picker-column__item--selected{
  background: #ddd;
}
.showbj{
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.noheight >>> .van-uploader__wrapper{
  padding-top: 0 !important;
}
.noheight >>> .van-field__body{
  height: 38px;
}
.notop{
  padding-top: 0;
}
.row-between{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.name{
  color: #0096FF;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue